module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=BZ - Belize.9ebb40c5.svg";